import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import App from 'antd/lib/app';
import { QueryKey } from '../../query-client';
import { fetchSettings, updateSettings } from './index';
import { ISettings } from './interface';

export const useCompanySettingsQuery = (companyId: number) => {
    const { notification } = App.useApp();

    return useQuery<ISettings, Error>({
        queryKey: [QueryKey.COMPANY_SETTINGS, companyId],
        queryFn: ({ signal }) => fetchSettings(companyId, signal),
        onError: error => {
            notification.error({ key: 'fetch-settings-data-error', message: error.message || 'Cannot fetch settings data!' });
        },
    });
};

export const useUpdateCompanySettingsMutation = (companyId: number) => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<ISettings, Error, ISettings>(settings => updateSettings(companyId, settings), {
        onSuccess: settings => {
            queryClient.setQueryData([QueryKey.COMPANY_SETTINGS, companyId], settings);
            notification.info({ key: 'settings-save-info', message: 'Settings saved' });
        },
        onError: error => {
            notification.error({ key: 'update-settings-data-error', message: error.message || 'Cannot update settings!' });
        },
    });
};
